import type { ReactElement } from "react";
import cx from "ui/cx";
import type { RadioButtonProps } from "ui/forms/RadioButton";
import styles from "./RadioButtonGroup.module.scss";

interface RadioButtonGroupProps {
  children: ReactElement<RadioButtonProps>[] | ReactElement<RadioButtonProps>;
  orientation: "vertical" | "horizontal";
}

export default function RadioButtonGroup({ children, orientation }: RadioButtonGroupProps) {
  return <div className={cx({ styles, wrapper: true, [orientation]: true })}>{children}</div>;
}
